import {makeObservable} from 'mobx';

import type {Nullable} from '../../../utils/utility-types';
import type {DateTimeModel} from '../Date/DateTime.model';
import type {OfferModel} from '../Offer/Offer.model';
import type {SubtenantModel} from '../Subtenant/Subtenant.model';
import type {UserModel} from '../User/User.model';

import {BaseModel} from '../../../core/domain/Base/Base.model';

const ModelName = 'CouponModel';

export class CouponModel extends BaseModel {
  code: string;
  createdDate: DateTimeModel;
  description: Nullable<string>;
  employer: Nullable<UserModel>;
  expirationDate: Nullable<DateTimeModel>;
  expiredDate: Nullable<DateTimeModel>;
  maxQty: Nullable<number>;
  offer: Nullable<OfferModel>;
  optionOffers: OfferModel[];
  role: Nullable<CouponModel.Role>;
  subtenant: Nullable<SubtenantModel>;
  title: string;
  type: CouponModel.Type;
  updatedDate: DateTimeModel;
  usedQty: number;
  value: number;

  constructor(props: CouponModel.Props) {
    super(props);
    Object.assign(this, props);

    makeObservable(
      this,
      BaseModel.mobxAnnotationFactory<CouponModel, CouponModel.Props>(props),
    );
  }

  get defaultOffer(): Nullable<OfferModel> {
    if (this.optionOffers.length) {
      return this.optionOffers[0]!;
    }

    return this.offer;
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }
}

export namespace CouponModel {
  export enum Role {
    CLIENT = 'client',
    COACH = 'coach',
  }

  export enum Type {
    EMPLOYEE = 'employee',
    EMPLOYER = 'employer',
    POINTS = 'points',
    SUBSCRIPTION = 'subscription',
  }

  export type Props = BaseModel.ModelToProps<CouponModel, 'defaultOffer'>;
}
